import script from "./ViewOrganizationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewOrganizationView.vue?vue&type=script&setup=true&lang=ts"

import "./ViewOrganizationView.vue?vue&type=style&index=0&id=1633cabd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1633cabd"]])

export default __exports__